import type { DescriptionProps as HeadlessDescriptionProps } from "@headlessui/react";
import { FeedbackMessage } from "./FeedbackMessage";

export function ErrorMessages({
  disabled,
  errors,
  ...props
}: {
  className?: string;
  disabled?: boolean;
  errors?: Array<string> | null;
} & HeadlessDescriptionProps) {
  return (
    errors &&
    errors.length > 0 &&
    errors.map((error) => (
      <FeedbackMessage key={error} disabled={disabled} type="error" {...props}>
        {error}
      </FeedbackMessage>
    ))
  );
}
